import React from 'react';
import { useTranslation } from 'react-i18next';

import { ICONS_MAP } from 'constants/icons';
import { appReactMemo } from 'hocs';
import { useBreadCrumbs } from 'hooks/useBreadcrumbs';

import { Active, Container, Disabled, IconWrapper } from './styled';

const BreadCrumb = () => {
  const { i18n, t } = useTranslation();
  const breadcrumbs = useBreadCrumbs();

  return (
    <Container data-testid='breadcrumbs'>
      {breadcrumbs.map(({ breadcrumb, url }, index) => {
        if (!breadcrumb) {
          return null;
        }

        if (breadcrumbs.length - 1 === index) {
          return (
            <Disabled key={`${url}-${index}`} size='md' variant='regular'>
              {i18n.exists(breadcrumb) ? t(breadcrumb as never) : breadcrumb}
            </Disabled>
          );
        }

        return (
          <React.Fragment key={`${url}-${index}`}>
            <Active to={url}>{t(breadcrumb as never)}</Active>
            <IconWrapper>
              <ICONS_MAP.MinimalRightArrow />
            </IconWrapper>
          </React.Fragment>
        );
      })}
    </Container>
  );
};

export default appReactMemo(BreadCrumb);
